import { createFileRoute } from "@tanstack/react-router";

import { OrgProfilePage } from "../iam/organization/components/OrgProfilePage";

/**
 * Route is /organizations/$organizationId/profile: the organization profile page.
 * Open to every role (the page renders an editable form for owner/admin and a
 * read-only row otherwise).
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/profile")({
  component: OrgProfilePage,
});
